import React from 'react';
import {
  Menu,
  Box,
  IconButton,
  Switch,
  FormControlLabel,
  styled,
} from '@mui/material';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import CheckBoxBase from '../../../../inputs/Checkbox';
import { TableStateContext } from '../../TableStateContext';
import SimpleTooltip from '../../../../SimpleTooltip';

export const ColumnChooser = ({ ...props }) => {
  // @ts-expect-error TS(2339): Property 'columns' does not exist on type 'unknown... Remove this comment to see the full error message
  const { columns, handlers, ...rest } = React.useContext(TableStateContext);
  return (
    <ColumnChooserBase {...props} {...handlers} {...rest} columns={columns} />
  );
};

export const ColumnChooserBase = ({ columns: originalColumns, ...props }) => {
  const anchorElRef = React.useRef(undefined);
  const [isOpen, setIsOpen] = React.useState(false);
  const [isSorted, setIsSorted] = React.useState(false);
  const alphabeticallySortedColumns = React.useMemo(
    () => sortColumnsByTitle(originalColumns),
    [originalColumns]
  );

  const displayedColumns = isSorted
    ? alphabeticallySortedColumns
    : originalColumns;

  const handleToggle = () => {
    setIsSorted(!isSorted);
  };

  return (
    <>
      {/* @ts-expect-error TS(2739): FIXME */}
      <ColumnChooserIcon ref={anchorElRef} onClick={() => setIsOpen(true)} />
      <Menu
        id="columnChooser-menu"
        anchorEl={anchorElRef.current}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        keepMounted
        open={isOpen}
        onClose={() => setIsOpen(false)}
        variant="menu"
      >
        <ColumnSwitchControlLabel
          value={isSorted}
          control={<Switch onChange={handleToggle} />}
          label="Alphabetical"
          // @ts-expect-error TS(2322): Type '"right"' is not assignable to type '"bottom"... Remove this comment to see the full error message
          labelPlacement="right"
          color="primary"
        />
        <ColumnChooserList {...props} columns={displayedColumns} />
      </Menu>
    </>
  );
};

const ColumnChooserItem = ({ column, onHiddenColumnNamesChange }: any) => {
  const value = column.name;

  return (
    <CheckBoxBase
      name={column.name}
      checked={column.show !== false}
      label={column.title}
      onChange={() => onHiddenColumnNamesChange(value)}
      color="primary"
    />
  );
};

const ColumnChooserList = ({ columns, ...props }: any) => {
  return (
    <Box
      style={{
        margin: '1rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      }}
    >
      {Object.values(columns).map((col) => (
        <React.Fragment
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          key={`column-chooser-item:${col.name}`}
        >
          {/* @ts-expect-error TS(2739): FIXME */}
          {col.canToggle !== false && !col.fixed ? (
            <ColumnChooserItem column={col} {...props} />
          ) : null}
        </React.Fragment>
      ))}
    </Box>
  );
};

// @ts-expect-error TS(2339): Property 'onClick' does not exist on type '{}'.
export const ColumnChooserIcon = React.forwardRef(({ onClick }, ref) => {
  return (
    // @ts-expect-error TS(2769): No overload matches this call.
    <IconButton
      onClick={onClick}
      size="small"
      style={{
        cursor: 'pointer',
        marginLeft: '0.4rem',
      }}
      ref={ref}
    >
      <SimpleTooltip title="Hide/Show Columns">
        <ViewColumnIcon
          style={{ fontSize: '2rem', position: 'relative', right: 2 }}
          color="primary"
        />
      </SimpleTooltip>
    </IconButton>
  );
});

export const ColumnSwitchControlLabel = styled(FormControlLabel)(() => ({
  marginLeft: '0',
}));

// sortColumnsByTitle: sorts the object 'columns' alphabetically based on title
function sortColumnsByTitle(columns: any) {
  const columnArray = Object.values(columns);

  columnArray.sort(function (a, b) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (a.title === undefined) {
      return -1;
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (b.title === undefined) {
      return 0;
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (a.title.toLowerCase() < b.title.toLowerCase()) {
      return -1;
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (a.title.toLowerCase() > b.title.toLowerCase()) {
      return 1;
    }
    return 0;
  });

  return Object.assign({}, columnArray);
}
